export enum RightsEnum {
    Read = "CanRead",
    Update = "CanUpdate",
    Create = "CanCreate",
    Delete = "CanDelete",
}
